module.exports = __webpack_public_path__ + "img/Pinguine.39049cfe.svg";